<template>
<div id="app">
  <b-navbar toggleable="lg" type="dark" variant="primary">
    <b-navbar-brand href="#"><img src="./assets/logo.png"></b-navbar-brand>
    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav>
        <b-nav-item :active="$route.path == '/'" to="/">Home</b-nav-item>
        <!-- <b-nav-item to="/kp27day">27 Day Kp Forecast</b-nav-item> -->
        <b-nav-item :active="$route.path == '/imagelist'" to="/imagelist">Images</b-nav-item>
        <b-nav-item href="#/archives">Data Archives</b-nav-item>
        <b-nav-item-dropdown text="More Info">
          <b-dropdown-item href="https://status.auroras.live">
            <plus-outline-icon /> System Status</b-dropdown-item>
          <b-dropdown-item href="https://text.auroras.live">
            <arrow-collapse-vertical-icon /> Text Only Site</b-dropdown-item>
          <b-dropdown-item href="https://auroraslive.io">
            <code-greater-than-or-equal-icon /> API Documentation</b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto">
        <b-nav-item href="#" @click="reloadData()" right>Reload</b-nav-item>
        <b-nav-item href="#" @click="appdata.editable = !appdata.editable" right>
          <lock-open-icon v-if="!appdata.editable" />
          <lock-icon v-if="appdata.editable" /> {{ appdata.editable ? 'Lock Widgets' : 'Edit Widgets' }}</b-nav-item>
        <b-nav-item :active="$route.path == '/settings'" to="/settings" right>Settings</b-nav-item>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
  <img v-if="appdata.loading == true" src="./assets/loading.gif" class="loading-right" />
  <b-alert dismissible v-if="error" show variant="danger">{{ error }}</b-alert>
  <b-container fluid>
    <keep-alive>
      <router-view :appdata="appdata"></router-view>
    </keep-alive>
  </b-container>
  <div class="footer mt-auto py-3">
    <div class="container">
      <span class="text-muted"><small>App last built {{ version }}</small></span>
    </div>
  </div>
</div>
</template>

<script>
import './assets/css/main.css'

import PlusOutlineIcon from 'vue-material-design-icons/PlusOutline.vue'
import LockIcon from 'vue-material-design-icons/Lock.vue'
import LockOpenIcon from 'vue-material-design-icons/LockOpen.vue'
import CodeGreaterThanOrEqualIcon from 'vue-material-design-icons/CodeGreaterThanOrEqual.vue'
import ArrowCollapseVerticalIcon from 'vue-material-design-icons/ArrowCollapseVertical.vue'

import axios from 'axios'

export default {
  name: 'app',
  components: {
    PlusOutlineIcon,
    CodeGreaterThanOrEqualIcon,
    LockIcon,
    LockOpenIcon,
    ArrowCollapseVerticalIcon
  },

  methods: {
    getLocation: function() {
      navigator.geolocation.getCurrentPosition(function(position) {
        this.position.lat = position.coords.latitude
        this.position.long = position.coords.longitude
        this.reloadData()
      }.bind(this), function() {
        console.error("Unable to determine location")
        this.error = "Unable to determine your location. Weather and Nowcast information may not be accurate"
        this.reloadData()
      }.bind(this));
    },

    reloadData: function() {
      axios.post('https://v2.api.auroras.live/', {
          "modules": this.modules,
          "common": {
            "lat": this.position.lat,
            "long": this.position.long
          },
          "format": {
            "date": {
              "tz": (window.localStorage.getItem('auroraslive-tz') || (new Date).getTimezoneOffset())
            },
            "color": {
              "format": "hex"
            }
          }
        }, {
          withCredentials: true //correct
        })
        .then(function(response) {
          this.appdata.response = response.data
        }.bind(this))
        .catch(function(error) {
          this.error = "There was an error loading the data. The error returned was " + error
        }.bind(this))
        .then(function() {
          this.appdata.loading = false
        }.bind(this))
    }
  },

  mounted() {
    this.getLocation()
    setInterval(function() {
      if (document.hasFocus()) {
        this.appdata.loading = true
        this.getLocation()
      }
    }.bind(this), 60000)
  },

  data() {
    return {
      modules: JSON.parse(window.localStorage.getItem('auroraslive-api-modules')) || ["common"],
      version: process.env.VUE_APP_VERSION,
      appdata: {
        loading: true,
        response: {},
        editable: false
      },
      position: {
        lat: null,
        long: null
      },
      error: null,
    }
  }
}
</script>

<style scoped>
.loading {
  width: 64px;
  left: 1%;
  position: absolute;
}

.loading-right {
  width: 32px;
  right: 1%;
  position: absolute;
}

.removeWidget {
  position: absolute;
  padding: 5px 0.75em;
  right: 0;
  text-decoration: none;
}

.vue-grid-item {
  border: 1px solid #666;
  padding: 0;
  border-collapse: collapse;
  background: rgba(255, 255, 255, 0.025);
  overflow-x: hidden;
}

.widget-item {
  overflow-x: hidden;
  overflow-y: auto;
}

.header-spacer {
  margin-top: 70px !important;
}

.widget-title {
  background: rgba(255, 255, 255, 0.05);
  padding: 5px;
}

::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-track {
  background: #272b30;
}

::-webkit-scrollbar-thumb {
  background: #6a6b6c;
}

::-webkit-scrollbar-thumb:hover {
  background: #8a8b8c;
}
</style>
